import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const Wrapper = styled(FlexColumn)`
  width: 100%;
  padding: 24px;

  gap: 24px;

  ${QUERIES.largeTabletAndUp} {
    padding: 24px 48px;
  }
`;

export const Background = styled(FlexColumn)<{
  backgroundGradient?: string;
}>`
  margin: 0 auto;
  width: 100%;
  max-width: 1344px;
  box-sizing: border-box;

  ${({ backgroundGradient }) =>
    backgroundGradient
      ? `background: ${backgroundGradient}`
      : `background-image: url('/images/landing/background.png');`};

  background-size: cover;
  background-position: center;

  border-radius: 20px;
  border: 1px solid ${themeStyle.varInkSuperLight};
  overflow: hidden;
`;

export const DescriptionSection = styled.div<{ alignCenter: boolean }>`
  color: ${themeStyle.darkInkMedium};

  text-align: ${({ alignCenter }) => (alignCenter ? 'center' : 'left')};
  ${QUERIES.smallDesktopAndUp} {
    padding: ${({ alignCenter }) => (alignCenter ? '0 120px' : '')};
  }
`;
